import {ActiveStatus} from 'src/app/shared/model/survey-association-my-suffix.model';
export interface IUmr {
    id?: number;
    umrNo?: string;
    year?: number;
    activeStatus?: ActiveStatus;
    isUsedInCertificate?: boolean;

}

export class Umr implements IUmr {
    constructor(
        public id?: number,
        public umrNo?: string,
        public year?: number,
        public activeStatus?: ActiveStatus,
        public isUsedInCertificate?: boolean
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}